import { render, staticRenderFns } from "./entity-table.vue?vue&type=template&id=1383ba0a&"
import script from "./entity-table.ts?vue&type=script&lang=ts&"
export * from "./entity-table.ts?vue&type=script&lang=ts&"
import style0 from "./entity-table.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports